import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { setPaymentOverdueDate, resetPaymentOverdueDate } from 'utils/paymentService'
import moment from 'moment-timezone'
import { utcCurrentDate } from 'utils/helpers'
import { isAdmin } from 'utils/authService'
import { makePaymentsGetRequest } from 'utils/api'

const withSubscriptionNotification = Component => {
  function ComponentWithSubscriptionNotification() {
    const dispatch = useDispatch()
    const { unpaidInvoices, subscriptions } = useSelector(state => state.login)

    useEffect(() => {
      if (isAdmin() && typeof subscriptions === 'object' && !subscriptions.status) {
        dispatch({
          type: 'SUBSCRIPTIONS_FETCH_REQUESTED'
        })
        dispatch({
          type: 'CREDIT_CARD_VALID_FETCH_REQUETED'
        })
      }
    }, [dispatch, subscriptions])

    useEffect(() => {
      if (isAdmin()) {
        if (unpaidInvoices) {
          const filteredInvoices = unpaidInvoices.filter(
            i => i.status === 'open' && moment(i.dueDate) <= moment(utcCurrentDate())
          )
          const hasOverduePayment = !!filteredInvoices.length
          if (hasOverduePayment) {
            setPaymentOverdueDate(filteredInvoices[0].dueDate)
          } else {
            resetPaymentOverdueDate()
          }
        } else {
          dispatch({
            type: 'UNPAID_INVOICES_FETCH_REQUETED'
          })
        }
      } else {
        ;(async () => {
          try {
            const isValid = await makePaymentsGetRequest('/v1/subscriptions/is_valid')
            if (!isValid) {
              setPaymentOverdueDate(isValid)
            } else {
              resetPaymentOverdueDate()
            }
            // eslint-disable-next-line no-empty
          } catch (error) {}
        })()
      }
    }, [dispatch, unpaidInvoices])

    return <Component />
  }

  return ComponentWithSubscriptionNotification
}

export default withSubscriptionNotification
